export enum OrderSetupStepsLabelEnum {
    NUMBER_OF_SAMPLES = 'order.setup.numberOfSamples',
    REACTION_DETAILS = 'order.setup.reactionDetails',
    ORDER_SUMMARY = 'order.orderSummary',
}

export enum OrderSetupStepsNumberEnum {
    NUMBER_OF_SAMPLES = 0,
    REACTION_DETAILS = 1,
    ORDER_SUMMARY = 2,
}
